import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { CicloI } from "interfaces/Ciclo";
import { EspecialidadI } from "interfaces/especialidad";
import { NivelI } from "interfaces/Nivel";
import { Dropdown } from "react-bootstrap";
import { deleteCiclo } from "services/ciclo";
import { deleteEspecialidad } from "services/especialidad";
import { deleteNiveles } from "services/niveles";

interface Props {
  elemento: EspecialidadI;
  onClickEdit: (elemento: EspecialidadI) => void;
  refreshTable: () => void;
}

export const EspecialidadRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteEspecialidad(id);
      showSuccessToast("¡La especialidad fue eliminada con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la especialidad: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar especialidad"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la especialidad {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
